// اضافه کردن کتابخانه ها به صفحه
import * as React from 'react';
import NavBar from "../../components/NavBar";
import {ContentCopy} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {useSnackbar} from "notistack";
import HandleFetchData from "../../plugin/HandleFetchData";


export default function Affiliate() {
  // استفاده از متود های i18n برای چند زبان کردن پروژه و تغییر زبان پروژه
  const {t} = useTranslation()
  const {enqueueSnackbar} = useSnackbar();
  const {fetchData} = HandleFetchData()

  const [userInfo, setUserInfo] = React.useState(null)
  const [affiliateCode, setAffiliateCode] = React.useState(null)

  React.useEffect(() => {
    const info = JSON.parse(localStorage.getItem('info-user'))
    setUserInfo(info)
    setTimeout(() => {
      addAffiliate()
    }, 1000)
  }, [])

  // متن کپی کردن لینک دعوت
  const copied = (link) => {
    enqueueSnackbar(t("dashboard.affiliate.t4"), {
      variant: 'success',
      TransitionProps: {
        direction: 'down',
      },
      anchorOrigin: {
        horizontal: 'center',
        vertical: 'top'
      }
    })
    navigator.clipboard.writeText(affiliateCode)
  }

  const addAffiliate = async () => {
    let fetch = await fetchData('', 'POST', '/addAffiliate', {
         "firstName": userInfo?.FirstName,
         "lastName": userInfo?.LastName,
         "email": userInfo?.Email,
         "company": null,
         "countryId": userInfo?.CountryId,
         "stateProvinceId": null,
         "city": userInfo?.City,
         "address1": null,
         "address2": null,
         "zipPostalCode": null,
         "phoneNumber": userInfo?.Phone,
         "faxNumber": null,
         "friendlyUrlName": null
       },
       "application/json",'', '',''
    )
  }


  const getAffiliate = async () => {
    let fetch = await fetchData('', 'GET', '/getAffiliateLink', '',
       "application/json",'', '',''
    )
    // setItems_Invoices(fetch)
    fetch.IsSuccess ?
       setAffiliateCode(fetch?.Data?.affiliateLink)
       :
       enqueueSnackbar(fetch?.Message, {
         variant: 'error',
         TransitionProps: {
           direction: 'down',
         },
         anchorOrigin: {
           horizontal: 'center',
           vertical: 'top'
         }
       })
  }


  return (
     <>
       {/*کامپوننت نوبار*/}
       <div className="d-block d-lg-none">
         <NavBar blue back/>
       </div>

       <div className="container">
         <div className="presentationPage">
           <h4 className="titleSection">{t("dashboard.affiliate.t1")}</h4>
           <div>
             <img src={require('../../assets/img/score.png')} alt="score" loading="lazy"/>
           </div>

           <div>
             <h5>{t("dashboard.affiliate.t2")}</h5>
             <p>{t("dashboard.affiliate.t3")}</p>

             {
               affiliateCode ?
                  <button className="affiliate" id="affiliate" onClick={() => copied('http://postex.ir/?affiliate=32778734')}>
                    <span>{affiliateCode}</span>
                    <ContentCopy/>
                  </button>
                  :
                  <div className="btnGroup_yellow">
                    <button type="button" id="getAffiliate" className="btnFill" onClick={() => getAffiliate()}>
                    <span>{t("dashboard.affiliate.t2")}</span>
                  </button>
               </div>

               }



               </div>
               </div>
               </div>

               </>
               )
             }
